'use client';

import { useState, useEffect } from 'react';
import { launchConfetti } from './lib/confetti';
import { playIconClickSound } from './lib/sounds';
import { triggerHaptic } from './lib/haptics';

export default function Home() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  const handleAvatarClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    playIconClickSound();
    triggerHaptic('success');
    launchConfetti(centerX, centerY);
  };

  return (
    <div className="wukko-wrapper">
      <main className={`wukko-main ${loaded ? 'loaded' : ''}`}>
        <div id="introduction">
          <div className="heading">
            <div className="avatar-holder">
              <button
                type="button"
                className="avatar-button"
                onClick={handleAvatarClick}
                aria-label="eenymeenyminy.moe"
              >
                <img
                  src="/favicon.svg?v=3"
                  alt="eenymeenyminy.moe"
                  className="avatar-image"
                  width={38}
                  height={38}
                />
              </button>
            </div>
            <h2>eenymeenyminy.moe</h2>
          </div>
        </div>
      </main>

      <noscript>
        <style>{`
          .wukko-main {
            opacity: 1 !important;
            visibility: visible !important;
          }
        `}</style>
      </noscript>
    </div>
  );
}